import { filter, map, take } from 'rxjs/operators';

import { Injectable } from '@angular/core';
import { HttpService } from 'services/http/http.service';
import { createFileUploadHeaders } from 'utils/helpers';
import { buildFormData } from 'utils/formdata-builder';
import { ShowIfHttpError } from '@certemy/common';
import { SmartModalService } from '@certemy/ui-components';

@Injectable()
export class LogService {
  constructor(private http: HttpService, private smartModalService: SmartModalService) {}

  @ShowIfHttpError('An error occurred while deleting the entry. Please, try again later.')
  removeEntry(stepId, entryId) {
    return this.http.delete(`/certification_step_instance/${stepId}/log_form/${entryId}`);
  }

  @ShowIfHttpError('Entry has not been requested. Please, try again.')
  readEntry(stepId, entry) {
    return this.http.get(`/certification_step_instance/${stepId}/log_form/${entry}`).pipe(map(res => res.result));
  }

  @ShowIfHttpError('An error occurred while saving an entry. Please, try again later.')
  saveEntry(stepId, entryId, entryData) {
    return this.http.put(`/certification_step_instance/${stepId}/log_form/${entryId}`, entryData);
  }

  @ShowIfHttpError('An error occurred while saving an entry. Please, try again later.')
  createEntry(stepId, entryData) {
    return this.http.post(`/certification_step_instance/${stepId}/log_form`, entryData);
  }

  @ShowIfHttpError('An error occurred while while uploading file. Please try again.')
  parseFileWithLogFormData(stepId, fileForm) {
    const options = createFileUploadHeaders();
    const formData = buildFormData(fileForm, 'files');
    return this.http
      .post(`/certification_step_instance/${stepId}/log_form/parse_file`, formData, options)
      .pipe(map(res => res.result));
  }

  prepareEntryPayload({ type, data, fields = [], saveAsDraft = false, signature_link = '' }) {
    if (type === 'multiple') {
      return { log_forms: data };
    } else if (type === 'single') {
      return this.buildLogFormPayload({ entryData: data, saveAsDraft, signature_link });
    }
  }

  private buildLogFormPayload({ entryData, saveAsDraft, signature_link }) {
    return {
      log_form: {
        fields: entryData,
        saveAsDraft,
        ...(signature_link ? { signature_link } : {}),
      },
    };
  }

  showUnsavedMessage({ text, ignoreFilter }: { text?: string; ignoreFilter?: boolean } = {}) {
    return this.smartModalService
      .openConfirm({
        title: 'Unsaved changes',
        body: text || 'Do you really want to close form without saving the changes?',
        successButtonText: 'Confirm',
      })
      .pipe(
        take(1),
        filter(canDeactivate => ignoreFilter || canDeactivate),
      );
  }
}
